<template>
  <div>
    <form @submit.prevent="submit()">
      <div class="mb-3">
        <SGPFormInputComponent 
            type="text" 
            :name="'autenticacao'"
            v-model="formulario.autenticacao" 
            :placeholder="'Autenticação'"
            data-vv-as="Autenticação"
            v-validate="'required|max:50'"
            :error="validationErrors.first('autenticacao')"
         />
      </div>
      <div>
        <SGPFormInputComponent 
            type="textarea"
            rows="3"
            name="descricao"
            v-model="formulario.descricao" 
            placeholder="Descrição"
            data-vv-as="Descrição"
            v-validate="'max:255'"
            :error="validationErrors.first('descricao')"
         />
      </div>
      <div class="container-botoes">
        <button class="v-btn v-btn--has-bg v-btn--rounded theme--light v-size--default primary text-capitalize" type="submit">
          {{ tipoFormulario === 'salvar' ? 'Salvar' : 'Atualizar' }}
        </button>
        <button class="v-btn v-btn--outlined v-btn--rounded theme--light v-size--default grey-5--text text-capitalize" type="button" @click="fecharModal()">Cancelar</button>
     </div>
      
    </form>
    

  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
export default {
  name: "FormularioAclAutenticacaoComponent",

  props: {
    tipoFormulario: {
      type: String,
      required: false,
      default: 'salvar'
    },
    autenticacao: {
      type: Object,
      required: false
    }
  },

  data () {
    return {
      formulario: this.$props.autenticacao || {
        autenticacao: ''
      }
    }
  },
  computed: {
    ...mapGetters('aclAutenticacoes', ['listaDeAutenticacoes'])
  },
  methods: {
    ...mapActions('aclAutenticacoes', [
      'salvarAutenticacao',
      'atualizarAutenticacao'
    ]),
     validate: function () {
          this.$validator.validateAll();
        },
     limparCampos () {
       this.formulario.autenticacao = '';
        this.$validator.reset();
     },   
    submit () {
      // invoca o vee validade para a validação dos campos
       this.$validator.validateAll().then(async (result) => {
        if (result) {
          // eslint-disable-next-line
          if(this.tipoFormulario === 'salvar') {
            const resp = await this.salvarAutenticacao(this.formulario);            
            if(!resp) { 
              return;
            }
          }else{
              const resp = await this.atualizarAutenticacao(this.formulario);
              if(!resp){
                return;
              } 
          }

          this.limparCampos();
          this.fecharModal();
          return;
        }
      });     
       
    },

    fecharModal () {
      this.$parent.$parent.$parent.$parent.fecharModal()
    }
  }


}
</script>